<template>
  <div class="max-w-7xl mx-auto">
    <div v-if="students.length == 0" class="m-4 p-4 flex justify-center rounded bg-blue-100">
      <div class="">
        <slot>
          No students yet
        </slot>
      </div>
    </div>
    <div class="flex flex-col" v-else>
      <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
        <div class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-cool-gray-200 relative">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="sticky top-0 bg-cool-gray-100">
              <tr>
                <th class="px-6 py-3 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                  Name
                </th>
                <th class="px-6 py-3 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                  Grade Level
                </th>
                <th class="px-6 py-3 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider text-right">
                  Contacts
                </th>
                <th class="px-6 py-3 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider text-right">
                  Recent Contact
                </th>
              </tr>
            </thead>
            <tbody>

              <router-link tag="tr"
                class="bg-white hover:bg-gray-50 focus:outline-none focus:bg-gray-50 cursor-pointer"
                v-for="s in students"
                :key="s.id"
                :to="{name: 'student', params: {studentId: s.id}}"
              >
                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900">
                  {{s.last}}, {{s.first}}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                  {{gradeLevelName(s)}}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500 text-right">
                  {{s.communicationCount}}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500 text-right">
                  <MonthDayInTimezone :timestamp="s.mostRecentCommunication"></MonthDayInTimezone>
                </td>
              </router-link>

            </tbody>
          </table>
          <nav
            v-if="paginate"
            class="bg-cool-gray-100 px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6"
          >
            <div v-if="count && page && pageSize" class="hidden sm:block">
              <p class="text-sm leading-5 text-gray-700">
                Showing
                <span class="font-medium">{{startNum}}</span>
                to
                <span class="font-medium">{{endNum}}</span>
                of
                <span class="font-medium">{{count}}</span>
                students
              </p>
            </div>
            <div class="flex-1 flex justify-between sm:justify-end">
              <router-link
                v-if="canPagePrevious"
                :to="pagePrevious"
                class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm leading-5 font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:ring-blue focus:border-blue-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
              >
                Previous
              </router-link>
              <router-link
                v-if="canPageNext"
                :to="pageNext"
                class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm leading-5 font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:ring-blue focus:border-blue-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
              >
                Next
              </router-link>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _get               from 'lodash-es/get'
import _sortBy            from 'lodash-es/sortBy'
import _take              from 'lodash-es/take'
import _reverse           from 'lodash-es/reverse'
import _ceil              from 'lodash-es/ceil'
import _slice             from 'lodash-es/slice'
import _partition         from 'lodash-es/partition'

import MonthDayInTimezone from '@/components/MonthDayInTimezone.vue'

export default {
  components: {
    MonthDayInTimezone
  },

  props: {
    students: {
      type: Array,
      required: false,
      default: () => [],
    },
    paginate: {
      type: Boolean,
      default: false
    },
    canPagePrevious: {
      type: Boolean,
      default: false
    },
    canPageNext: {
      type: Boolean,
      default: false
    },
    pagePrevious: {
      type: Object,
      default: false
    },
    pageNext: {
      type: Object,
      default: false
    },
    pageSize: {
      type: Number,
      required: false
    },
    page: {
      type: Number,
      required: false
    },
    count: {
      type: Number,
      required: false
    }
  },

  methods: {
    gradeLevelName (s) {
      return _get(s, 'gradeLevel.name')
    }
  },

  computed: {
    endNum() {
      var endNum = this.pageSize * this.page
      if (endNum > this.count) {
        return this.count
      } else {
        return endNum
      }
    },

    startNum() {
      if (this.endNum < this.pageSize) {
        return this.endNum - this.endNum + 1
      } else {
        return this.endNum + 1 - this.students.length
      }
    },
  }
}
</script>
